import React from "react";
import Typography from "@material-ui/core/Typography";
import ListaTags from "../components/ListaTags";
import {avanceResources, forzadosResources, tagResources} from "../endpoints";
import SnackbarAlert from "../components/SnackbarAlert";
import useToken from "../useToken";

class TagsAvance extends React.Component{
    constructor(props) {
        let datos_inv = useToken.getDatos()
        super(props);
        this.state={
            idUbicacion: props.match.params.ubicacion,
            tipo: props.match.params.tipo,
            datos:[],
            columnas:[],
            ubicacion: props.match.params.descripcion,
            openSnack:false,
            severity: null,
            message:null,
            titulo_columna : (datos_inv.app === 'sodimac'? 'Costo':'Importe'),
        }
    }

    definirColumnas =()=>{
        if(this.state.tipo ==="contados"){
            const columnas = [
                { title: 'Tag', field: 'id' },
                { title: 'Registros rev.(%)', field: 'registros_revisados',
                    render: rowData => ((((rowData.registros_revisados *100)/ rowData.registros)* 100)/100).toFixed(2),
                    customFilterAndSearch: ((term, rowData) => ((((rowData.registros_revisados *100/ rowData.registros)* 100)/100).toFixed(2)).indexOf(term) !== -1),
                },
                { title: 'Cant. Capt.', field: 'cantidad',
                    render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.cantidad)),
                    customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.cantidad).indexOf(term) !== -1)},
                { title: 'Cant. Fin', field: 'cantidad_umb',
                    render : (rowData => new Intl.NumberFormat("de-DE").format(rowData.cantidad_umb)),
                    customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.cantidad_umb).indexOf(term) !== -1)},
                { title: this.state.titulo_columna, field: 'importe',
                    render: (rowData => new Intl.NumberFormat("de-DE").format(rowData.importe)),
                    customFilterAndSearch: ((term, rowData) => new Intl.NumberFormat("de-DE").format(rowData.importe).indexOf(term) !== -1)},
                { title: this.state.titulo_columna + ' rev.(%)', field: 'importe_revisado',
                    render: rowData => rowData.importe !== 0 ? ((((rowData.importe_revisado * 100)/ rowData.importe)* 100)/100).toFixed(2) : (0.00).toFixed(2),
                    customFilterAndSearch: ((term, rowData) =>  rowData.importe !== 0 ? (((((rowData.importe_revisado * 100)/ rowData.importe)* 100)/100).toFixed(2).indexOf(term) !== -1) : ((0.00).toFixed(2).indexOf(term) !== -1)),
                },
            ]
            this.setState({columnas: columnas})
        }
        else if (this.state.tipo ==="negativos"){
            const columnas = [
                { title: 'Tag', field: 'id' },
                { title: 'Material', field: 'articulo' },
                { title: 'Cantidad', field: 'cantidad' },

            ]
            this.setState({columnas: columnas})
        }
        else{
            const columnas = [
                { title: 'Tag', field: 'id'}
            ]
            this.setState({columnas: columnas})
        }
    }

    consultarTagsUbicacion = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        if(this.state.tipo ==="contados"){
            avanceResources.getTagsContadosUbicacion(this.state.idUbicacion).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.contados})
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }
        else if (this.state.tipo ==="nulos"){
            avanceResources.getTagsNulosUbicacion(this.state.idUbicacion).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.nulos})
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }
        else if (this.state.tipo ==="forzados"){
            forzadosResources.getTagForzados().then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.forzados})
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }
        else if (this.state.tipo ==="negativos"){
            tagResources.getNegativos().then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.negativos})
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }
        else{
            avanceResources.getTagsPendientesUbicacion(this.state.idUbicacion).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.pendientes})
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }
    }

    refrescarTagsUbicacion=()=>{
        this.consultarTagsUbicacion()
    }

    componentDidMount() {
        this.consultarTagsUbicacion()
        this.definirColumnas()
    }

    render() {
        return(
            <div>
                <Typography hidden={this.state.ubicacion === "null"} variant="h4" gutterBottom>Tags {this.state.tipo} - {this.state.ubicacion}</Typography>
                <Typography hidden={this.state.ubicacion !== "null"} variant="h4" gutterBottom>Tags con {this.state.tipo}</Typography>
                <ListaTags id_ubicacion={this.state.idUbicacion} datos={this.state.datos} columnas={this.state.columnas} tipo={this.state.tipo} refrescarTags={this.refrescarTagsUbicacion}/>
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default TagsAvance